import { dropDownColorPicker, DropDownColorPicker, GridLayout, Input } from '@Common/Controls';
import { MulticastDelegate } from '@Common/Core/MulticastDelegate';
import { TypeKind } from '@Common/Enums';
import { BackgroundGradientStop } from '@InstanceFactory';
import { enumerable } from '@Common/Core/CoreDecorator';

export class GradientStopControl {
    private readonly color: DropDownColorPicker;
    private readonly offset: Input;
    private grid: GridLayout;
    private currentStop: BackgroundGradientStop;
    private onChanged: MulticastDelegate = new MulticastDelegate();

    @enumerable
    public get changedEvent(): MulticastDelegate {
        return this.onChanged;
    }

    constructor() {
        this.color = dropDownColorPicker({});
        this.color.onChange(() => {
            this.currentStop.color = this.color.getValue();
            this.onChanged.fire(this);
        });
        this.offset = new Input({ type: TypeKind.int });
        this.offset.onChange(() => {
            this.currentStop.offset = this.offset.getValue() / 100;
            this.onChanged.fire(this);
        });
        this.grid = new GridLayout({
            style: { padding: '5px' },
            rows: [{ style: { height: 'auto' } }, { style: { height: '*' } }],
            columns: [
                { style: { width: '*' } },
                { style: { width: 'auto' } },
                { style: { width: '100px' } },
                { style: { width: 'auto' } },
                { style: { width: '100px' } },
                { style: { width: 'auto' } }
            ],
            cells: [
                { columnIndex: 1, rowIndex: 0, content: strings.gradientEditor.color, style: { padding: '2px' } },
                { columnIndex: 2, rowIndex: 0, content: this.color, style: { padding: '2px' } },
                {
                    columnIndex: 3,
                    rowIndex: 0,
                    content: strings.gradientEditor.location,
                    style: { padding: '2px', paddingLeft: '5px' }
                },
                { columnIndex: 4, rowIndex: 0, content: this.offset, style: { padding: '2px' } },
                { columnIndex: 5, rowIndex: 0, content: '%', style: { padding: '2px' } }
            ]
        });
    }

    public value(val?: BackgroundGradientStop): BackgroundGradientStop {
        if (arguments.length !== 0) {
            this.setValue((this.currentStop = val));
        }
        return this.currentStop;
    }

    private setValue(gs: BackgroundGradientStop): void {
        if (!gs) {
            this.color.setValue(null);
            this.offset.setValue(null);
        } else {
            this.color.setValue(gs.color);
            this.offset.setValue(Math.round(gs.offset * 100));
        }
    }

    public enabled(val?: boolean): boolean {
        if (arguments.length === 0) {
            return this.grid.enabled();
        }
        return this.grid.enabled(val);
    }

    public getControl(): JQuery {
        return this.grid.getControl();
    }

    public adjust(w: number, h: number): void {
        return this.grid.adjust(w, h);
    }
}
